import React from 'react';
import AppLoader from '@projectK/components/AppLoader';
import PropTypes from 'prop-types';

const AppTableLoader = ({ loading ,className}) => {
  if (!loading) return null;

  return (
    <div className={className}>
      <AppLoader />
    </div>
  );
};

export default AppTableLoader;

AppTableLoader.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
};



